import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cls from 'classname';

import { Form, Input, Button } from 'antd';
import { MailOutlined, EyeInvisibleOutlined, LockOutlined } from '@ant-design/icons';

import Checkbox from '../Checkbox';
import Images from '../../Images';
import Icon from '../../Icon';

const style = {
  fontSize: '20px',
}

function LoginForm({ rememberMe, setRemember, onSubmit, error, ...props }) {

  const [errorText, setErrorText] = useState(null);
  const [isBackError, setIsBackError] = useState(false);

  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      setIsBackError(true);
      if (typeof error === 'string') {
        setErrorText(error);
      } else {
        setErrorText(Object.values(error)[0]);
      }
    }
  }, [error]);

  const onFinish = values => {
    if (rememberMe) setRemember(values);
    onSubmit(values);
  };

  const onFinishFailed = ({ errorFields }) => {
    if (errorFields) setErrorText(errorFields[0]['errors']);
  };

  function onChange(e) {
    if (e.target.checked) {
      let data = form.getFieldsValue();
      setRemember(data);
    } else {
      setRemember(null);
    }
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: [],
      },
    ]);
    setErrorText(null);
    setIsBackError(false);
  }

  function onBlurHandler(e) {
    const target = e.target;

    setTimeout(() => {
      let error = form.getFieldError(target.name);
      if (error.length) {
        setErrorText(error[0]);
      }
    }, 10);
  }

  return (
    <Form onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          validateTrigger='onSubmit'
          className="login-form"
          layout="vertical"
          form={form}
    >
      <Form.Item noStyle shouldUpdate={true}>
        {() => <div className={cls('error-text', { 'error-text_empty': !errorText })}>{errorText}</div>}
      </Form.Item>

      <Form.Item label=""
                 name="email"
                 initialValue={rememberMe?.email}
                 validateStatus={errorText || isBackError ? 'error' : null}
                 rules={[
                   { type: 'email', message: t('The email or password you entered is incorrect.') },
                   { required: true, message: t('The email or password you entered is incorrect.') },
                 ]}
      >
        <Input
          placeholder={t('Email Address')}
          name="email"
          // prefix={<img src={Images.email} alt=""/>}
          prefix={<MailOutlined style={style}/>}
          onChange={e => handleClearError(e, 'email')}
          onBlur={onBlurHandler}
        />
      </Form.Item>
      <Form.Item label=""
                 name="password"
                 initialValue={rememberMe?.password}
                 validateStatus={errorText || isBackError ? 'error' : null}
                 rules={[{ required: true, message: t('The email or password you entered is incorrect.') }]}
      >
        <Input.Password
          size="large"
          placeholder={t('Password')}
          autoComplete="new-password"
          visibilityToggle
          // prefix={<img src={Images.lock} alt=""/>}
          prefix={<LockOutlined style={{ fontSize: 22}}/>}
          onChange={e => handleClearError(e, 'password')}
          // iconRender={visible => (
          //   visible
          //     ? <EyeInvisibleOutlined style={{...style, color: '#237cfb'}} />
          //     : <EyeInvisibleOutlined style={style} />
          // )
          iconRender={visible => (
            visible
              ? <Icon type='eye' color={'#237cfb'}/>
              : <Icon type='eye_invisible' color={'#cddffa'}/>
            )
          }
        />
      </Form.Item>

      <Button type="primary" htmlType="submit" className="btn-primary" style={{ width: '100%' }}>
        {t('Sign In')}
      </Button>

      <div className="bottom-part">
        <Checkbox
          type={'path'}
          checked={!!rememberMe}
          onChange={onChange}
        >
          {t('Remember Me')}
        </Checkbox>
        <Link to="/restore-password">{t('Forgot Password?')}</Link>
      </div>

      {
        props.children
      }

    </Form>
  );
}

export default LoginForm;
